<app-main-layout>
  <app-team-directory-page></app-team-directory-page>
</app-main-layout>
